import block from 'bem-cn-lite';
import React, {useCallback} from 'react';

import {HTML} from '@doc-tools/components';
import {ClassNameProps} from '@yandex-data-ui/cloud-components';
import {CardBase, CardBaseProps} from '@yandex-data-ui/page-constructor';

import {isServiceNavigationItem} from 'units/constructor-local/models';

import {NavigationSectionType} from 'units/navigation/models';
import {getNavigationItemLink, getLinks} from 'units/navigation/utils';
import {NavigationItemExtended} from 'models/app';
import withTranslation, {WithTranslationProps} from 'hoc/withTranslation';
import {I18nKFunction, I18nOptions} from 'i18n';
import ServiceLogo from 'units/constructor-local/components/ServiceLogo/ServiceLogo';
import Tag from 'units/navigation/components/NavigationItems/Tag/Tag';

import './NavigationCardItem.scss';

const b = block('navigation-card-item');

interface NavigationCardItemProps {
    item: NavigationItemExtended;
    type: NavigationSectionType;
}

export type NavigationCardItemExtendedProps = NavigationCardItemProps &
    WithTranslationProps &
    CardBaseProps &
    ClassNameProps;

const NavigationCardItem: React.FC<NavigationCardItemExtendedProps> = (props) => {
    const {item, className, type = NavigationSectionType.Services, i18n} = props;
    const {slug, description, name} = item;

    const i18nK: I18nKFunction = useCallback(
        (key: string, params?: I18nOptions) =>
            i18n(type || NavigationSectionType.Services, key, params),
        [i18n, type],
    );
    const isServiceData = isServiceNavigationItem(item);
    const links = isServiceData ? getLinks(item) : undefined;
    const tag = <Tag item={item} type={type} />;

    //TODO refactoring NavigationCardItem & ServicePreviewCard CLOUDFRONT-7967
    return (
        <CardBase
            className={b(null, className)}
            url={getNavigationItemLink(slug, type)}
            contentClassName={b('content')}
        >
            <CardBase.Content>
                <div className={b('content-top')}>
                    <div className={b('logo-tag')}>
                        {isServiceData && <ServiceLogo service={slug} />}
                        {tag}
                    </div>
                    <h6 className={b('title')}>
                        <HTML>{name || ''}</HTML>
                    </h6>
                    {description && <HTML>{description}</HTML>}
                </div>
                {links && (
                    <div className={b('links')}>
                        {links.map((link) => (
                            <a href={link.url} key={link.url}>
                                {i18nK(link.text)}
                            </a>
                        ))}
                    </div>
                )}
            </CardBase.Content>
        </CardBase>
    );
};

export default withTranslation()(NavigationCardItem);
